import { gql } from 'graphql-request'

import { useMutation } from '@hooks/graphql'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog'

const EXPORT_RESEARCH_DATA_MUTATION = gql`
  mutation exportResearchData($input: ExportResearchDataInput!) {
    exportResearchData(input: $input) {
      success
      errors {
        message
      }
    }
  }
`

const RequestResearchDataModal = ({
  closeModal,
  isOpen,
  classroomId
}) => {
  const { mutate: exportResearchData, isLoading: isExportingResearchData } = useMutation({
    gqlMutation: EXPORT_RESEARCH_DATA_MUTATION,
    variables: { input: { classroomId } },
    onSuccess: () => {
      closeModal()
    }
  })

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeModal()}>
      <DialogContent className='sm:max-w-[425px]'>
        <DialogHeader>
          <DialogTitle>Request research data</DialogTitle>
          <DialogDescription />
        </DialogHeader>
        <p className='text-sm'>
          Are you sure you'd like to request research data for this classroom?
        </p>
        <p className='text-sm'>
          You will receive an email with a link to download the data.
          Please allow for a few hours for the data to be ready.
        </p>
        <DialogFooter>
          <Button
            onClick={() => exportResearchData()}
            disabled={isExportingResearchData}
            loading={isExportingResearchData}
          >
            Request research data
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default RequestResearchDataModal
